<!-- =========================================================================================
  File Name: TicketList.vue
  Description: Ticket List
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Webspiders
  Author URL: https://www.webspiders.com
========================================================================================== -->
<template>
  <div class="team-page-wrap-area">
     <vs-tabs alignment="center" ref="checkin_tabs">
      <vs-tab label="Invite Team">
        <div>
          <div class="team-header-hld">
            <div class="header-custome mb-0">
              <h3>Invite Check-In Team <feather-icon icon="InfoIcon" /></h3>
            </div>
            <div class="team-head-right">
              <vs-button  @click="getUser(null)" color="#1a73e8" type="filled" class="send-team-invi-button disable-button-invitation mr-4"><feather-icon icon="UserPlusIcon" class="mr-2" /> Add User</vs-button>
              <vs-button @click="getMailTpls()" color="#1a73e8" type="filled" class="send-team-invi-button disable-button-invitation mr-4"><feather-icon icon="MailIcon" class="mr-2" /> Send Invitation</vs-button>
              <vs-button @click="$router.push('/event/checkintype');" color="#1a73e8" type="filled" class="send-team-invi-button disable-button-invitation"><feather-icon icon="GridIcon" class="mr-2" /> Manage Type</vs-button>
              <!-- <input type="text" value="" placeholder="Search"/> -->
            </div>
          </div>
          <div class="mt-5 invite-team-list">
            <vs-table  max-items="10" pagination  multiple search v-model="checkedUsers" :data="users_data">
              <template slot="header">
                  <h3>
                    Checkin Staff
                  </h3>
                </template>
              <template slot="thead">   
                  <vs-th sort-key="Name">Name</vs-th>
                  <vs-th sort-key="Email">Email</vs-th>                  
                  <vs-th sort-key="InvitationStatus" class="status-bar text-left">Status</vs-th>                
                  <vs-th sort-key="IsPublished">Publish</vs-th>                
              </template>
              <template slot-scope="{data}">
                <vs-tr :data="user" :key="indextr" v-for="(user, indextr) in data">
                  <vs-td><h5>{{user.Name}}</h5></vs-td>
                  <vs-td><h5>{{user.Email}}</h5></vs-td>
                  <vs-td>  <InvitationStatus :status="user.InvitationStatus" />
                  </vs-td>
                  <vs-td>
                    <vs-switch v-model="user.IsPublished" @input="setPublishStatus(user)" />
                  </vs-td>
                </vs-tr>

                <!-- <vs-tr>
                  <vs-td><vs-checkbox></vs-checkbox></vs-td>
                  <vs-td><h5>Antonie Barnes</h5></vs-td>
                  <vs-td>
                    <h5>antonie.barnes@samplemail.com</h5>
                  </vs-td>
                  <vs-td>
                    <div class="activate-member-status">
                      <p>Accepted</p>
                    </div>
                  </vs-td>
                  <vs-td>
                    <vs-button @click="popupActivo6=true" color="#767676" type="border" class="team-invite-button"><feather-icon icon="XSquareIcon" class="mr-2" /> Remote Access</vs-button>
                  </vs-td>
                </vs-tr>

                <vs-tr>
                  <vs-td><vs-checkbox></vs-checkbox></vs-td>
                  <vs-td><h5>Susan R. Keen</h5></vs-td>
                  <vs-td>
                    <h5>susan.keen@samplemail.com</h5>
                  </vs-td>
                  <vs-td>
                    <div class="pending-member-status">
                      <p>Pending</p>
                    </div>
                  </vs-td>
                  <vs-td>
                    <vs-button color="#1a73e8" type="border" class="team-invite-button"><feather-icon icon="RotateCwIcon" class="mr-2" /> Re-Assign</vs-button>
                  </vs-td>
                </vs-tr>

                <vs-tr>
                  <vs-td><vs-checkbox></vs-checkbox></vs-td>
                  <vs-td><h5>Floyed Mitchell</h5></vs-td>
                  <vs-td>
                  <h5>floyed.mitchell@samplemail.com</h5>
                  </vs-td>
                  <vs-td>
                    <div class="rejected-member-status">
                      <p>Rejected</p>
                    </div>
                  </vs-td>
                  <vs-td>
                    <vs-button color="#1a73e8" type="border" class="team-invite-button"><feather-icon icon="RotateCwIcon" class="mr-2" /> Re-Assign</vs-button>
                  </vs-td>
                </vs-tr>  -->               
              </template>
            </vs-table>
          </div>
        </div>
      </vs-tab>
      <vs-tab label="Overview">
        <div>
          <div class="team-header-hld">
            <div class="filter-option-checkin">
              <!-- <input type="text" value="" placeholder="Search" class="search-filter"/> -->
              <!-- <input type="text" value="" placeholder="Search" class="date-filter"/>
              <select>
                <option selected>Select Type</option>
                <option>Type 1</option>
                <option>Type 2</option>
                <option>Type 3</option>
                <option>Type 4</option>
              </select> -->
              <vs-dropdown vs-trigger-click class="cursor-pointer">
                <div
                  class="p-3 shadow-drop rounded-lg d-theme-dark-light-bg cursor-pointer flex items-end justify-center text-lg font-medium w-32"
                >
                  <span class="mr-2 leading-none">Actions</span>
                  <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                </div>

                <vs-dropdown-menu>                  
                  <vs-dropdown-item @click="exportOverview">
                    <span class="flex items-center">
                      <feather-icon
                        icon="SaveIcon"
                        svgClasses="h-4 w-4"
                        class="mr-2"
                      />
                      <span>Export</span>
                    </span>
                  </vs-dropdown-item>
                  
                </vs-dropdown-menu>
              </vs-dropdown>
            </div>
          </div>
          <div class="mt-5 checkin-report-table">
              <vs-table
                max-items="10" pagination
                multiple
                v-model="selectedOverviewRow"
                search 
                :data="checkinCurrentUsers">
                <template slot="header">
                  <h3>
                    Current Checkin Users
                  </h3>
                </template>
                <template slot="thead">
                  <vs-th sort-key="StaffName">
                    Staff
                  </vs-th>
                  <vs-th  sort-key="Name">
                    Name
                  </vs-th>
                  <vs-th  sort-key="Email">
                    Email
                  </vs-th>
                  <vs-th  sort-key="CheckinType">
                    Type of Check-in
                  </vs-th>
                  <vs-th  sort-key="ScanType">
                    Type of Scan
                  </vs-th>
                  <vs-th>
                    Check-in Date &amp; Time
                  </vs-th>
                  <!-- <vs-th>
                    Action
                  </vs-th> -->
                </template>

                <template slot-scope="{data}">
                  <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" >
                    <vs-td :data="data[indextr].StaffName">
                      <h5>{{data[indextr].StaffName}}</h5>
                    </vs-td>

                    <vs-td :data="data[indextr].Name">
                      <h5>{{data[indextr].Name}}</h5>
                    </vs-td>

                    <vs-td :data="data[indextr].Email">
                      <h5>{{data[indextr].Email}}</h5>
                    </vs-td>

                    <vs-td :data="data[indextr].CheckinType">
                      <h5>{{data[indextr].CheckinType}}</h5>
                    </vs-td>

                    <vs-td :data="data[indextr].ScanType">
                      <h5>{{data[indextr].ScanType}}</h5>
                    </vs-td>

                    <vs-td :data="data[indextr].CheckInTime">
                      <h5>{{data[indextr].CheckInTime | SetTimeByZone}}</h5>
                    </vs-td>
                    <!-- <vs-td>
                      <vs-button color="#767676" type="border" class="team-invite-button"><feather-icon icon="XCircleIcon" class="mr-2" /> Remove</vs-button>
                    </vs-td> -->
                  </vs-tr>
                </template>
              </vs-table>
            <!-- <pre>{{ selected }}</pre> -->
          </div>
        </div>
      </vs-tab>
      <vs-tab label="Log History">
        <div>
          <div class="team-header-hld">
            <div class="filter-option-checkin">
              <!-- <input type="text" value="" placeholder="Search" class="search-filter"/> -->
              <!-- <input type="text" value="" placeholder="Search" class="date-filter"/>
              <select>
                <option selected>Select Type</option>
                <option>Type 1</option>
                <option>Type 2</option>
                <option>Type 3</option>
                <option>Type 4</option>
              </select> -->
              <!-- ACTION - DROPDOWN -->
              <vs-dropdown vs-trigger-click class="cursor-pointer">
                <div
                  class="p-3 shadow-drop rounded-lg d-theme-dark-light-bg cursor-pointer flex items-end justify-center text-lg font-medium w-32"
                >
                  <span class="mr-2 leading-none">Actions</span>
                  <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                </div>

                <vs-dropdown-menu>                  
                  <vs-dropdown-item @click="exportLogHistory">
                    <span class="flex items-center">
                      <feather-icon
                        icon="SaveIcon"
                        svgClasses="h-4 w-4"
                        class="mr-2"
                      />
                      <span>Export</span>
                    </span>
                  </vs-dropdown-item>
                  
                </vs-dropdown-menu>
              </vs-dropdown>
            </div>
          </div>
          <div class="mt-5 checkin-report-table">
              <vs-table
                max-items="10" pagination
                multiple
                search
                v-model="selectedLogRow"
                :data="checkinHistory">
                <template slot="header">
                  <h3>
                    Checkin History
                  </h3>
                </template>
                <template slot="thead">
                  <vs-th sort-key="StaffName">
                    Staff
                  </vs-th>
                  <vs-th  sort-key="Name">
                    Name
                  </vs-th>
                  <vs-th  sort-key="Email">
                    Email
                  </vs-th>
                  <vs-th  sort-key="CheckinType">
                    Type of Check-in
                  </vs-th>
                  <vs-th  sort-key="ScanType">
                    Type of Scan
                  </vs-th>
                  <vs-th>
                    Check-in Date &amp; Time
                  </vs-th>
                  <vs-th>
                    Check-out Date &amp; Time
                  </vs-th>
                  <!-- <vs-th>
                    Action
                  </vs-th> -->
                </template>

                <template slot-scope="{data}">
                  <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" >
                    <vs-td :data="data[indextr].StaffName">
                      <h5>{{data[indextr].StaffName}}</h5>
                    </vs-td>

                    <vs-td :data="data[indextr].Name">
                      <h5>{{data[indextr].Name}}</h5>
                    </vs-td>

                    <vs-td :data="data[indextr].Email">
                      <h5>{{data[indextr].Email}}</h5>
                    </vs-td>

                    <vs-td :data="data[indextr].CheckinType">
                      <h5>{{data[indextr].CheckinType}}</h5>
                    </vs-td>

                    <vs-td :data="data[indextr].ScanType">
                      <h5>{{data[indextr].ScanType}}</h5>
                    </vs-td>

                    <vs-td :data="data[indextr].CheckInTime">
                      <h5>{{data[indextr].CheckInTime | SetTimeByZone}}</h5>
                    </vs-td>
                    <vs-td :data="data[indextr].CheckOutTime">
                      <h5>{{data[indextr].CheckOutTime | SetTimeByZone}}</h5>
                    </vs-td>
                    <!-- <vs-td>
                      <vs-button color="#767676" type="border" class="team-invite-button"><feather-icon icon="XCircleIcon" class="mr-2" /> Remove</vs-button>
                    </vs-td> -->
                  </vs-tr>
                </template>
              </vs-table>
            <!-- <pre>{{ selected }}</pre> -->
          </div>
        </div>
      </vs-tab>
      
    </vs-tabs>
    
    <vs-popup class="holamundo send-invitation-popup"  title="" :active.sync="popupActivo2">
      <div class="invitation-pop-top"><h3>Send Invitation</h3></div>
      <div class="invitation-list-wrap">
        <div class="invitee-list">
          <div class="invitee-user-count">
            <p>5 users selected</p>
            <vs-button size="small" color="#fff" class="button-clear">Clear all <span>X</span></vs-button>
          </div>
          <div class="invited-people mt-4">
            <div class="single-invited">
              <div class="invited-image">
                <img src="../../assets/images/default_avatar.jpg"/>
              </div>
              <p>Floyed L. Santos</p>
              <span>X</span>
            </div>
            <div class="single-invited">
              <div class="invited-image">
                <img src="../../assets/images/default_avatar.jpg"/>
              </div>
              <p>Mario Hartley</p>
              <span>X</span>
            </div>
            <div class="single-invited">
              <div class="invited-image">
                <img src="../../assets/images/default_avatar.jpg"/>
              </div>
              <p>Noren T. Bowser</p>
              <span>X</span>
            </div>
            <div class="single-invited">
              <div class="invited-image">
                <img src="../../assets/images/default_avatar.jpg"/>
              </div>
              <p>Arthur Jackson</p>
              <span>X</span>
            </div>
            <div class="single-invited">
              <div class="invited-image">
                <img src="../../assets/images/default_avatar.jpg"/>
              </div>
              <p>Jason M. Lohmann</p>
              <span>X</span>
            </div>
            
          </div>
        </div>
        <div class="session-checkinlist">
          <h3>Select at least one session to invite the check-in team</h3>
          <div class="invited-session-list">
            <div class="select-all-session">
              <vs-checkbox v-model="checkBox11"></vs-checkbox>
              <p>Select all sessions</p>
            </div>
            <div class="single-invited-session-list">
              <vs-checkbox v-model="checkBox12"></vs-checkbox>
              <p>Opening Keynote</p>
            </div>
            <div class="single-invited-session-list">
              <vs-checkbox v-model="checkBox13"></vs-checkbox>
              <p>Executive Leadership Program</p>
            </div>
            <div class="single-invited-session-list">
              <vs-checkbox v-model="checkBox14"></vs-checkbox>
              <p>Mobile marketing - personal and tactile approach</p>
            </div>
            <div class="single-invited-session-list">
              <vs-checkbox v-model="checkBox15"></vs-checkbox>
              <p>Creating open standards and collaboration for future powertrain</p>
            </div>
            <div class="single-invited-session-list">
              <vs-checkbox v-model="checkBox16"></vs-checkbox>
              <p>How to approach early state investments for Saas companies?</p>
            </div>
            <div class="single-invited-session-list">
              <vs-checkbox v-model="checkBox17"></vs-checkbox>
              <p>Digital Disruption And How It Impacts You And You Business</p>
            </div>
          </div>
          <div class="proceed-btn">
            <vs-button @click="popupActivo2=false" color="#dadae2" type="border" class="mr-2">Cancel</vs-button>
            <vs-button @click="popupActivo3=true" color="#1a73e8" type="filled">Send Invite</vs-button>
          </div>
        </div>
        
      </div>
      
      <vs-popup class="success-invite-send" title="" :active.sync="popupActivo3">
        <div class="success-invite-send-wrap">
          <img src="../../assets/images/done.png"/>
          <h2>Check-In invitation has been sent to the selected users</h2>
          <vs-button @click="popupActivo2 = popupActivo3=false" class="mt-5" color="#1a73e8" type="filled">OK</vs-button>
        </div>
      </vs-popup>
    </vs-popup>

    <vs-popup class="holamundo send-invitation-popup"  title="" :active.sync="popupActivo4">
      <div class="invitation-pop-top"><h3>Send Invitation</h3></div>
      <div class="invitation-list-wrap">
        <div class="invitee-list ">
          <div class="invitee-user-count">
            <p>1 users selected</p>
          </div>
          <div class="invited-user-profile mt-3">
            <div class="selected-invitee-image">
              <img src="../../assets/images/default_avatar.jpg"/>
              <!-- <div class="invite-name-initial">
                <h4>FS</h4>
              </div> -->
            </div>
            <h4>Franklyn Sneed</h4>
            <p>Latino Policy &amp; Politics Initiative Founding Director </p>
            <div class="invited-contact-details">
              <ul>
                <li><span><img src="../../assets/images/envelope2.svg"/></span> <a href="">franklyn.s@example.com</a></li>
                <li><span><img src="../../assets/images/contact.svg"/></span> <a href="">+91 9388807624</a></li>
                <li><span><img src="../../assets/images/earth.svg"/></span> <a href="">www.lppi.com</a></li>
              </ul>
            </div>
            <div class="invited-description">
              <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>
            </div>
          </div>
        </div>
        <div class="session-checkinlist">
          <h3>Select at least one session to invite the check-in team</h3>
          <div class="invited-session-list">
            <div class="select-all-session">
              <vs-checkbox v-model="checkBox11"></vs-checkbox>
              <p>Select all sessions</p>
            </div>
            <div class="single-invited-session-list">
              <vs-checkbox v-model="checkBox12"></vs-checkbox>
              <p>Opening Keynote</p>
            </div>
            <div class="single-invited-session-list">
              <vs-checkbox v-model="checkBox13"></vs-checkbox>
              <p>Executive Leadership Program</p>
            </div>
            <div class="single-invited-session-list">
              <vs-checkbox v-model="checkBox14"></vs-checkbox>
              <p>Mobile marketing - personal and tactile approach</p>
            </div>
            <div class="single-invited-session-list">
              <vs-checkbox v-model="checkBox15"></vs-checkbox>
              <p>Creating open standards and collaboration for future powertrain</p>
            </div>
            <div class="single-invited-session-list">
              <vs-checkbox v-model="checkBox16"></vs-checkbox>
              <p>How to approach early state investments for Saas companies?</p>
            </div>
            <div class="single-invited-session-list">
              <vs-checkbox v-model="checkBox17"></vs-checkbox>
              <p>Digital Disruption And How It Impacts You And You Business</p>
            </div>
          </div>
          <div class="proceed-btn">
            <vs-button @click="popupActivo4=false" color="#dadae2" type="border" class="mr-2">Cancel</vs-button>
            <vs-button @click="popupActivo5=true" color="#1a73e8" type="filled">Send Invite</vs-button>
          </div>
        </div>
        
      </div>
      
      <vs-popup class="success-invite-send" title="" :active.sync="popupActivo5">
        <div class="success-invite-send-wrap">
          <img src="../../assets/images/done.png"/>
          <h2>Check-In invitation has been sent to the selected user</h2>
          <vs-button @click="popupActivo5 = popupActivo4=false" class="mt-5" color="#1a73e8" type="filled">OK</vs-button>
        </div>
      </vs-popup>
    </vs-popup>

    <vs-popup class="holamundo send-invitation-popup"  title="" :active.sync="popupActivo6">
      <div class="invitation-pop-top"><h3>Send Invitation</h3></div>
      <div class="invitation-list-wrap">
        <div class="invitee-list ">
          <div class="invitee-user-count">
            <p>1 users selected</p>
          </div>
          <div class="invited-user-profile mt-3">
            <div class="selected-invitee-image">
              <img src="../../assets/images/default_avatar.jpg"/>
              <!-- <div class="invite-name-initial">
                <h4>FS</h4>
              </div> -->
            </div>
            <h4>Franklyn Sneed</h4>
            <p>Latino Policy &amp; Politics Initiative Founding Director </p>
            <div class="invited-contact-details">
              <ul>
                <li><span><img src="../../assets/images/envelope2.svg"/></span> <a href="">franklyn.s@example.com</a></li>
                <li><span><img src="../../assets/images/contact.svg"/></span> <a href="">+91 9388807624</a></li>
                <li><span><img src="../../assets/images/earth.svg"/></span> <a href="">www.lppi.com</a></li>
              </ul>
            </div>
            <div class="invited-description">
              <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>
            </div>
          </div>
        </div>
        <div class="session-checkinlist">
          <h3>Select at least one session to invite the check-in team</h3>
          <div class="invited-session-list">
            <div class="select-all-session">
              <vs-checkbox v-model="checkBox11"></vs-checkbox>
              <p>Select all sessions</p>
            </div>
            <div class="single-invited-session-list">
              <vs-checkbox v-model="checkBox12"></vs-checkbox>
              <p>Opening Keynote</p>
            </div>
            <div class="single-invited-session-list">
              <vs-checkbox v-model="checkBox13"></vs-checkbox>
              <p>Executive Leadership Program</p>
            </div>
            <div class="single-invited-session-list">
              <vs-checkbox v-model="checkBox14"></vs-checkbox>
              <p>Mobile marketing - personal and tactile approach</p>
            </div>
            <div class="single-invited-session-list">
              <vs-checkbox v-model="checkBox15"></vs-checkbox>
              <p>Creating open standards and collaboration for future powertrain</p>
            </div>
            <div class="single-invited-session-list">
              <vs-checkbox v-model="checkBox16"></vs-checkbox>
              <p>How to approach early state investments for Saas companies?</p>
            </div>
            <div class="single-invited-session-list">
              <vs-checkbox v-model="checkBox17"></vs-checkbox>
              <p>Digital Disruption And How It Impacts You And You Business</p>
            </div>
          </div>
          <div class="proceed-btn">
            <vs-button @click="popupActivo6=false" color="#dadae2" type="border" class="mr-2">Cancel</vs-button>
            <vs-button @click="popupActivo7=true" color="#1a73e8" type="filled">Done</vs-button>
          </div>
        </div>
        
      </div>
      
      <vs-popup class="success-invite-send" title="" :active.sync="popupActivo7">
        <div class="success-invite-send-wrap cancel-access">
          <img src="../../assets/images/access-remove.png"/>
          <h2>Are you sure you want to remove access?</h2>
          <vs-button @click="popupActivo6 = popupActivo7=false" class="mt-5 mr-2" color="#dadae2" type="border">Yes</vs-button>
          <vs-button @click="popupActivo6 = popupActivo7=false" class="mt-5" color="#dadae2" type="border">No</vs-button>
        </div>
      </vs-popup>
    </vs-popup>

    <vs-popup class="holamundo add-user-popup"  title="" :active.sync="popupAaddUser">
      <div class="adduser-pop-top"><h3>Add User</h3></div>
      <div v-if="UserDetail" class="add-user-hld">
        <label>First Name</label>
        <input type="text" v-model="UserDetail.FirstName"/>
        <label>Last Name</label>
        <input type="text" v-model="UserDetail.LastName"/>
        <label>Email</label>
        <input type="email" v-model="UserDetail.Email"/>

        <div class="add-user-btn">
            <vs-button @click="popupAaddUser=false" color="#dadae2" type="border" class="mr-2">Cancel</vs-button>
            <vs-button @click="addUser" color="#1a73e8" type="filled">Add</vs-button>
        </div>
      </div>
      
      <vs-popup class="success-invite-send" title="" :active.sync="popupActivo9">
        <div class="success-invite-send-wrap add-user">
          <img src="../../assets/images/done.png"/>
          <h2>The user has been successfully added.</h2>
          <vs-button @click="popupAaddUser = popupActivo9=false" class="mt-5 mr-2" color="#1a73e8" type="filled">OK</vs-button>
        </div>
      </vs-popup>
    </vs-popup>

    <!-- mail send popup start-->
  <vs-popup
    mailpopup
    class="holamundo customnewpopup"
    title="Mail Preview"
    :active.sync="popupActiveMail"
  >
    <div class="vx-col md:w-1/1 w-full mt-4">
      <label>Choose Template</label>
      <v-select :clearable="false" label="DisplayLabel" v-model="selectedMailPath" :options="mailtplData" @input="getMailTpl" />
      <div class="mail-template-switch-btn">
      </div>
    </div>
    <vs-tabs>
      <vs-tab label="Preview">
        <div class="tab-text">
          <div class="vx-row" style="width: 622px">
            <div class="vx-col md:w-1/1 w-full mt-4 email-temp-head">
              <h3>Subject: {{ MailSubject }}</h3>
            </div>
            <br />
            <div v-html="MailHtml"></div>
            <br />
            <div class="vx-col md:w-1/1 w-full mt-4">
              <div click="sendbtn-section">
                <vs-button color="rgb(76, 139, 246)" type="filled" @click="cancelMail"
                  >Cancel</vs-button
                >
                <vs-button
                  class="mail-btn"
                  color="rgb(76, 139, 246)" type="filled"
                  @click="sendMail"
                  >Send Mail</vs-button
                >
              </div>
            </div>
          </div>
        </div>
      </vs-tab>
      <vs-tab label="Edit">
        <div class="tab-text">
          <div class="vx-row" style="width: 622px;">
            <div class="vx-col md:w-1/1 w-full mt-4">
              Subject:
              <vs-input
                class="inputx w-full mt-4"
                v-model="MailSubject"
                v-validate="'required'"
                name="Subject"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('Subject')"
                >{{ errors.first("Subject") }}</span
              >
              <br />Body:                      
              <ckeditor
                class="desc-event"
                v-model="MailHtml"
                :config="editorConfig"
              ></ckeditor>
              <br />
              <div click="sendbtn-section">
                <vs-button color="rgb(76, 139, 246)" type="filled" @click="cancelMail"
                  >Cancel</vs-button
                >
                <vs-button
                  class="mail-btn"
                  color="rgb(76, 139, 246)" type="filled"
                  @click="before_save"
                  >Save</vs-button
                >
              </div>
            </div>
          </div>
        </div>
      </vs-tab>
    </vs-tabs>
  </vs-popup>
  </div>
</template>
<script>
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import vSelect from "vue-select";
import moment from "moment-timezone";
import ls from "@/common/localStorage"
import CKEditor from "ckeditor4-vue";
import CKconfig from "@/assets/ckeditor-config.ts";

// Store Module
import moduleCheckinteamManagement from "@/store/checkinteam-management/moduleManagement.js";
import moduleAttendeeManagement from "@/store/attendee-management/moduleAttendeeManagement.js";
import moduleMailtplManagement from "@/store/mailtpl-management/moduleMailtplManagement.js";

// Cell Renderer
import InvitationStatus from "./cell-renderer/InvitationStatus.vue";
import CellRendererActions from "./cell-renderer/CellRendererActions.vue";

var Session_Event_TZ = ls.getSessionValueByKey("Session_Event_TZ");
export default {
  components: {
    vSelect,
    ckeditor: CKEditor.component,
    // Cell Renderer
    InvitationStatus,
    CellRendererActions,
  },
  
  data() {
    
    return {
      checkBox11: false,
      checkBox12: true,
      checkBox13: true,
      checkBox14: false,
      checkBox15: false,
      checkBox16: false,
      checkBox17: false,
      popupActivo2:false,
      popupActivo3:false,
      popupActivo4: false,
      popupActivo5: false,
      popupActivo6: false,
      popupActivo7: false,      
      popupActivo9: false,
      selected:[],      
      /////////////// dynamic
      editorConfig: CKconfig.editorConfig,
      users: [],
      checkedUsers: [],  
      popupAaddUser: false,
      UserDetail: null,
      MailHtml: null,
      MailSubject: null,
      mailRecepients: [],
      selectedMailPath: null,
      popupActiveMail: false,
      checkinHistory: [],
      checkinCurrentUsers: [],
      selectedLogRow: [],
      selectedOverviewRow: []
    };
  },
  watch: {
  },
  computed: {
    mailtplData() {
      return this.$store.state.mailtplManagement.mailtpls.filter(item=> ['Custom'].includes(item.CollectionName));
    },
    users_data() {
      let user_data = this.users.map(item=>{
        item.Name = item.FirstName +" "+ item.LastName
        return item
      })
      return user_data;
    }
  },
  filters: {
    SetTimeByZone(data){
      if(data){
        let strDateTime = new Date(data.seconds * 1000).toUTCString();                  
        var date = moment.tz(strDateTime, Session_Event_TZ).format("MMM DD, YYYY hh:mm A");
        return date;
      }else{
        return null
      }
    }
  },
  methods: {
    async getMailTpls(){
      this.$vs.loading(); 
      this.MailHtml = null;
      this.MailSubject = null;
      this.selectedMailPath = null;
      await this.$store.dispatch("mailtplManagement/fetchMailtpls");
      this.popupActiveMail = true;
      this.$vs.loading.close();   
    },
    getMailTpl() {
      this.$vs.loading();      
      this.MailHtml = "Loading...";
      this.$store
        .dispatch("attendeeManagement/getMailTemplate", this.selectedMailPath)
        .then((res) => {
          this.MailHtml = res.html;
          this.MailSubject = res.subject;
          this.$vs.loading.close();          
        });
    },
    before_save() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          // if form have no errors
          this.saveMail();
        }
      });
    },
    saveMail() {
      if(this.selectedMailPath && this.MailSubject){
        this.$vs.loading();
        this.$store
          .dispatch("attendeeManagement/saveMail", {
            html: this.MailHtml,
            subject: this.MailSubject,
            tplpath: this.selectedMailPath,
          })
          .then((res) => {
            //alert(res.message)
            this.$vs.notify({
              color: "success",
              title: "Mail Saved",
              text: res.message,
            });
            this.$vs.loading.close();
          })
          .catch((err) => {
            //console.error(err)
            this.$vs.loading.close();
          });
      }else{
        this.$vs.notify({
          position: "top-center",
          color: "warning",
          text: "Template and Subject mandatory! "
        });
      }
    },
    sendMail() {
      let selectedRows = this.checkedUsers;
      if (selectedRows.length > 400) {
        this.$vs.notify({
          //type: "alert",
          position: "top-center",
          color: "warning",
          //title: "Status",
          text: "Mail cannot be sent more than 400 attendee at a time!",
          //acceptText: "OK",
        });
        return false;
      }
      selectedRows.map((row) => {
        //console.log(row);
        this.mailRecepients.push(row.UserId);
      });
      if (this.mailRecepients.length && this.MailSubject) {
        this.$vs.loading();
        this.$store
          .dispatch("attendeeManagement/sendMail", {
            data: this.mailRecepients,
            subject: this.MailSubject,
            tplpath: this.selectedMailPath,
          })
          .then(async(res) => {
            //alert(res.message)
            await this.$store.dispatch("checkinteamManagement/updateStatus", {status: 'Invited', userIds: this.mailRecepients});
            this.$vs.notify({
              position: 'top-center',
              color: "success",
              title: "Mail Sent",
              text: res.message,
            });
            this.mailRecepients = [];
            this.checkedUsers = [];
            this.getUsers();
            this.$vs.loading.close();
          })
          .catch((err) => {
            //console.error(err)
            this.$vs.loading.close();
          });
      } else {
        this.$vs.notify({
          position: 'top-center',
          color: "warning",
          //title: "Mail Sent",
          text: "Please select recipient!",
        });
      }
      this.popupActiveMail = false;
    },    
    cancelMail() {
      this.popupActiveMail = false;
      this.previewSelectedTemplate = "Reminder";
        var element2 = document.getElementById("reminderTemp");
        element2.classList.add("active");
        var element = document.getElementById("announcementTemp");
        element.classList.remove("active");
    },
    getUsers(){ 
      this.$store.dispatch("checkinteamManagement/fetchTeams").then(res=>{
        this.users = res
        for(let staff of res){
          if(staff.CheckIn && staff.CheckIn.History){
            for(let user of staff.CheckIn.History){
              this.checkinHistory.push({
                StaffName: `${staff.FirstName} ${staff.LastName}`,
                StaffEmail: staff.Email,
                StaffId: staff.UserId,
                Name: user.Name ? user.Name : null,
                Email: user.Email ? user.Email : null,
                CheckinType: user.docType ? user.docType : null,
                ScanType: user.ScanType ? user.ScanType : null,
                CheckInTime: user.checkInTime,
                CheckOutTime: user.checkOutTime
              });
            }
          }
          if(staff.CheckIn && staff.CheckIn.Current){
            for(let user of staff.CheckIn.Current){
              this.checkinCurrentUsers.push({
                StaffName: `${staff.FirstName} ${staff.LastName}`,
                StaffEmail: staff.Email,
                StaffId: staff.UserId,
                Name: user.Name ? user.Name : null,
                Email: user.Email ? user.Email : null,
                CheckinType: user.docType ? user.docType : null,
                ScanType: user.ScanType ? user.ScanType : null,
                CheckInTime: user.checkInTime
              });
            }
          }
        }
      })
    },
    getUser(userid){
      this.$vs.loading();
      this.$store.dispatch("checkinteamManagement/fetchUserDetail", userid).then(res=>{
        this.$vs.loading.close();
        this.UserDetail = res.data;
        this.popupAaddUser = true;
      }).catch(err=>{
        this.$vs.loading.close();
        this.$vs.notify({
          color: "warning",
          position: "top-center",
          text: "Something went wrong!",
        });
      })
    },
    setPublishStatus(userData){
      //console.log(userData)
      this.$vs.loading();
      this.$store.dispatch("checkinteamManagement/setPublishStatus", {status:userData.IsPublished, userIds: [userData.UserId]}).then(res=>{
        this.$vs.loading.close();
        this.getUsers();
      }).catch(err=>{
        this.$vs.loading.close();
        this.$vs.notify({
          color: "warning",
          position: "top-center",
          text: "Something went wrong!",
        });
      })
    },
    addUser(){
      if(this.UserDetail.FirstName && this.UserDetail.Email){
        this.$vs.loading();
        this.$store.dispatch("checkinteamManagement/addUser", {data:this.UserDetail}).then(res=>{
          this.$vs.loading.close();   
          if(res.status == 200){  
            this.getUsers();
            this.popupAaddUser = false
            this.UserDetail = null;
            this.$vs.notify({
              color: "success",
              position: "top-center",
              text: "User added successfully",
            });
          }else{
            this.$vs.notify({
              color: "warning",
              position: "top-center",
              text: "Unable to add",
            });
          }
        }).catch(err=>{
          console.log(err)
          this.$vs.loading.close();
          this.$vs.notify({
            color: "warning",
            position: "top-center",
            text: "Something went wrong!",
          });
        })
      }else{
        this.popupAaddUser = false;
        this.$vs.dialog({
          type: "alert",
          position: "top-center",
          color: "warning",
          title: "Status",
          text: "FirstName and Email field mandatory!",
          //accept: this.deleteRecord,
          acceptText: "OK",
        });
      }
    },
    exportLogHistory() {
      if (this.selectedLogRow.length > 0) {
         var datarow = [];         
         var userLoginData = [];
          datarow.push("Staff");
          datarow.push("Name");
          datarow.push("Email");
          datarow.push("Type of Check-in");
          datarow.push("Type of Scan");
          datarow.push("Check-in Date & Time");
          datarow.push("Check-out Date & Time");
          userLoginData.push(datarow);
          this.selectedLogRow.map((row1) => {
            datarow = [];
            var StaffName = row1.StaffName == undefined ? "" : row1.StaffName;
            datarow.push('"' + StaffName.trim() + '"');
            var Name = row1.Name == undefined ? "" : row1.Name;
            datarow.push('"' + Name.trim() + '"');
            var Email = row1.Email == undefined ? "" : row1.Email;
            datarow.push('"' + Email.trim() + '"');
            var CheckinType = row1.CheckinType == undefined ? "" : row1.CheckinType;
            datarow.push('"' + CheckinType.trim() + '"');
            var ScanType = row1.ScanType == undefined ? "" : row1.ScanType;
            datarow.push('"' + ScanType.trim() + '"');
            var CheckInTime = row1.CheckInTime == undefined ? "" : `"${this.$options.filters.SetTimeByZone(row1.CheckInTime)}"`;
            datarow.push(CheckInTime);
            var CheckOutTime = row1.CheckOutTime == undefined ? "" : `"${this.$options.filters.SetTimeByZone(row1.CheckOutTime)}"`;
            datarow.push(CheckOutTime);
            userLoginData.push(datarow);
          });
          let csvContent = "data:text/csv;charset=utf-8,";
          var dt = new Date().toISOString().slice(0, 10);
          userLoginData.forEach(function (rowArray) {
            let row = rowArray.join(",");
            csvContent += row + "\r\n";
          });
          var filename = "CheckinLogHistoryReport" + "_" + dt + ".csv";
          var encodedUri = encodeURI(csvContent);
          var link = document.createElement("a");
          link.setAttribute("href", encodedUri);
          //link.setAttribute("id", "Participance_RT_" + row.TableId);
          link.setAttribute("download", filename);
          document.body.appendChild(link); // Required for FF

          link.click();
      } else {
        this.$vs.dialog({
          type: "alert",
          color: "warning",
          title: "Download Sponser Reports",
          text: "Please select a row. ",
          acceptText: "OK",
        });
      }
    },
    exportOverview() {
      if (this.selectedOverviewRow.length > 0) {
         var datarow = [];         
         var userLoginData = [];
          datarow.push("Staff");
          datarow.push("Name");
          datarow.push("Email");
          datarow.push("Type of Check-in");
          datarow.push("Type of Scan");
          datarow.push("Check-in Date & Time");
          userLoginData.push(datarow);
          this.selectedOverviewRow.map((row1) => {
            datarow = [];
            var StaffName = row1.StaffName == undefined ? "" : row1.StaffName;
            datarow.push('"' + StaffName.trim() + '"');
            var Name = row1.Name == undefined ? "" : row1.Name;
            datarow.push('"' + Name.trim() + '"');
            var Email = row1.Email == undefined ? "" : row1.Email;
            datarow.push('"' + Email.trim() + '"');
            var CheckinType = row1.CheckinType == undefined ? "" : row1.CheckinType;
            datarow.push('"' + CheckinType.trim() + '"');
            var ScanType = row1.ScanType == undefined ? "" : row1.ScanType;
            datarow.push('"' + ScanType.trim() + '"');
            var CheckInTime = row1.CheckInTime == undefined ? "" : `"${this.$options.filters.SetTimeByZone(row1.CheckInTime)}"`;
            datarow.push(CheckInTime);
            userLoginData.push(datarow);
          });
          let csvContent = "data:text/csv;charset=utf-8,";
          var dt = new Date().toISOString().slice(0, 10);
          userLoginData.forEach(function (rowArray) {
            let row = rowArray.join(",");
            csvContent += row + "\r\n";
          });
          var filename = "CheckinOverviewReport" + "_" + dt + ".csv";
          var encodedUri = encodeURI(csvContent);
          var link = document.createElement("a");
          link.setAttribute("href", encodedUri);
          //link.setAttribute("id", "Participance_RT_" + row.TableId);
          link.setAttribute("download", filename);
          document.body.appendChild(link); // Required for FF

          link.click();
      } else {
        this.$vs.dialog({
          type: "alert",
          color: "warning",
          title: "Download Sponser Reports",
          text: "Please select a row. ",
          acceptText: "OK",
        });
      }
    },
  },
  mounted() {
    this.getUsers();
  },
  created(){    
    if (!moduleAttendeeManagement.isRegistered) {
      this.$store.registerModule("attendeeManagement", moduleAttendeeManagement);
      moduleAttendeeManagement.isRegistered = true;
    }
    if (!moduleCheckinteamManagement.isRegistered) {
      this.$store.registerModule(
        "checkinteamManagement",
        moduleCheckinteamManagement
      );
      moduleCheckinteamManagement.isRegistered = true;
    } 
    if (!moduleMailtplManagement.isRegistered) {
      this.$store.registerModule("mailtplManagement", moduleMailtplManagement);
      moduleMailtplManagement.isRegistered = true;
    }   
  }  
};
</script>

<style lang="scss">
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
.team-page-wrap-area{
  .team-header-hld{
    display: flex;
    justify-content: space-between;
    align-items: center;
  } 

  .header-custome h3{
    display: flex;
    align-items: center;
  }
  svg.feather.feather-info {
      height: 18px;
      width: 18px;
      margin-left: 6px;
      color: #919191;
  }
  button.send-team-invi-button {
    padding: 0 25px!important;
    height: 42px;
    
  }
  // .send-team-invi-button.disable-button-invitation{
  //   opacity: 0.5;
  // }
  .send-team-invi-button .vs-button-text {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .team-head-right {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
  .team-head-right input[type="text"] {
    width: 166px;
    height: 41px;
    margin: 0;
    border: 1px solid #dfdfdf;
    background: transparent !important;
    padding: 0 15px;
    margin-left: 15px;
    font-weight: 400;
    font-size: 14px;
    color: #333;
  }
  .team-head-right input[type="text"]:focus{outline: none !important;}
  .invite-team-list table {
    width: 100%;
     border-collapse: collapse;
  }
  .invite-team-list table thead tr th {
    padding-left: 0;
  }
  button.vs-component.vs-button.team-invite-button {
    width: 170px;
    height: 35px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 !important;
    margin: 0 auto;
  }
  button.vs-component.vs-button.team-invite-button span.vs-button-text {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .invite-team-list table thead tr {
      background: #f2f3f5;
      display: table-row;
      height: 50px;
      border-bottom: 1px solid #cdcdcd;
  }
  .invite-team-list table thead tr th {
    font-weight: 600;
    font-size: 15px;
    color: #545555;
  }
  
  .invite-team-list table thead tr th:first-child{width: 10%;}
  .invite-team-list table thead tr th:nth-child(2){width: 20%;}
  .invite-team-list table thead tr th:nth-child(3){width: 40%;}
  .invite-team-list table thead tr th:nth-child(4){width: 15%; text-align: center;}
  .invite-team-list table thead tr th:last-child{width: 15%; text-align: center;}
  .notinvited-status p {
    margin: 0;
    background: #e7e8ea;
    display: inline-block;
    padding: 6px 20px;
    border-radius: 5px;
    font-weight: 600;
    color: #5b6f88;
  }
  .assigned-event {display: flex; justify-content: flex-start; align-items: center;}
  .invite-team-list table tbody tr td:nth-child(4), .invite-team-list table tbody tr td:last-child{text-align: center;}
  .team-invite-button span.vs-button-text {font-weight: 600;}
  .invite-team-list table tr.vs-table--tr {border-bottom: 1px solid #cdcdcd;}
  .invite-team-list table thead tr th:last-child .vs-table-text{justify-content: center !important;}
  .invite-team-list .vs-component.con-vs-checkbox.vs-checkbox-default{justify-content: flex-start !important;}
  .notinvited-status, .activate-member-status, .pending-member-status, .rejected-member-status {text-align: center;}
  .activate-member-status p {font-weight: 600; font-size: 15px; background: #d8ebe4; padding: 6px 20px; display: inline-block; border-radius: 5px; color: #2fb182;}
  .assigned-event p {background: #e7e8ea; font-weight: 600; font-size: 15px; color: #434343; border-radius: 50px; padding: 6px 18px; margin-right: 8px;}
  .pending-member-status p {font-weight: 600;font-size: 15px; background: #f6e7c6; display: inline-block; color: #ffae01; padding: 6px 20px; border-radius: 5px;}
  .rejected-member-status p {
    background: #ffeef0;
    display: inline-block;
    color: #f03c55;
    font-size: 15px;
    font-weight: 600;
    padding: 6px 20px; border-radius: 5px;
}
}
.send-invitation-popup .vs-popup {
    width: 1254px !important;
    border-radius: 10px !important;
}
.send-invitation-popup .vs-popup--content {
    padding: 0 !important;
    margin: 0 !important;
}
.invitation-pop-top {
    border-bottom: 1px solid #d3d6db;
    padding: 22px 0;
    text-align: center;
}
.invitation-list-wrap {display: flex; justify-content: flex-start; align-items: flex-start;}
.invitee-list{height: 700px;background: #f3f6f8; padding: 20px; overflow-y: auto;width:35%; flex: 35% 0 0;}
.invitee-user-count {display: flex; justify-content: space-between; align-items: center;}
.invitee-user-count p {font-weight: 600; font-size: 14px; color: #1b1c26;}
button.vs-component.vs-button.button-clear {border-radius: 50px;}
.invitee-user-count .button-clear span.vs-button-text {color: #1a73e8 !important;font-size: 13px;font-weight: 600;}
.button-clear .vs-button-text span {margin-left: 6px; cursor: pointer;}
.single-invited {background: #fff; padding: 5px; border-radius: 50px; display: flex; justify-content: space-between; align-items: center;margin: 5px 5px 5px 0;}
.invited-image {height: 32px; width: 32px; overflow: hidden; display: flex; justify-content: center; align-items: center;border-radius: 50%;}
.invited-image img {max-width: 100%; height: auto;}
.single-invited p {font-weight: 400; color: #1c1d26; font-size: 15px; margin: 0; padding-left: 8px;}
.single-invited span {display: inline-block;padding-left: 8px; color: #1c1d26; cursor: pointer; font-weight: 400; font-size: 15px;}
.invited-people {display: flex; justify-content: flex-start; align-items: center; flex-wrap: wrap;}
.session-checkinlist{width: 65%; padding: 22px 35px;}
.select-all-session {background: #f2f3f5; display: flex; justify-content: flex-start; align-items: center; padding: 15px 8px; margin: 15px 0; border-radius: 3px;}
.invited-session-list {height: 569px; overflow-y: auto;}
.single-invited-session-list {display: flex; justify-content: flex-start; align-items: center; padding: 30px 0 30px 9px; position: relative;}
.single-invited-session-list:after {content: ""; position: absolute; width: 95%; background: #dfdfdf; right: 0; bottom: 0; height: 1px;}
.single-invited-session-list:last-child:after{display: none;}
.proceed-btn {display: flex; justify-content: end; align-items: center;}
.proceed-btn .vs-button-border span.vs-button-text {color: #1c1d26;}
.success-invite-send-wrap h2 {font-size: 30px; font-weight: 400; color: #000000; margin: 25px 0;}
.success-invite-send-wrap {text-align: center;}
.invited-user-profile{width: 100%; padding: 38px 30px; background: #ffffff; border-radius: 10px;}
.selected-invitee-image {height: 130px; width: 130px; margin: 0 auto; overflow: hidden; border-radius: 50%; display: flex; justify-content: center; align-items: center;}
.selected-invitee-image img{max-width: 100%; height: auto;}
.invite-name-initial { height: 100%; width: 100%; display: flex; justify-content: center; align-items: center; box-shadow: inset 0 0 28px rgba(0,0,0,0.5);}
.invite-name-initial h4{font-size: 30px; color: #1c1d26; margin: 0; font-weight: 600;}
.invited-user-profile h4 {text-align: center; margin-top: 15px;}
.invited-user-profile p {text-align: center; color: #7a7b86; font-weight: 600; width: 244px; margin: 0 auto;}
.invited-contact-details {margin: 30px 0; padding: 20px 0; border-top: 1px solid #d3d6db; border-bottom: 1px solid #d3d6db;}
.invited-contact-details ul li {display: flex; justify-content: flex-start; align-items: center;margin-bottom: 20px;}
.invited-contact-details ul li a {padding-left: 15px; display: inline-block; font-weight: 400; font-size: 16px; color: #333;overflow:hidden; text-overflow: ellipsis; white-space: nowrap;}
.invited-contact-details ul li:nth-child(2) a, .invited-contact-details ul li:last-child a{color: #1a73e8 !important;}
.invited-contact-details ul li:last-child{margin-bottom: 0;}
.invited-description p {color: #000; font-weight: 400; font-size: 15px; line-height: 20px; width: 100% !important; text-align: justify !important; height: 121px; overflow-y: auto;}
.proceed-btn button {width: 164px;}
.success-invite-send-wrap button {width: 120px;}
.success-invite-send-wrap.cancel-access button span.vs-button-text {
    color: #000;
    font-weight: 600;
    font-size: 15px;
}
.team-page-wrap-area ul.ul-tabs {border-bottom: 1px solid #dfdfdf;}
.filter-option-checkin {display: flex; justify-content: flex-start; align-items: center;}
input.search-filter {width: 300px; height: 50px; border: 1px solid #dfdfdf; border-radius: 5px; padding: 0 30px 0 15px; font-weight: 400; font-size: 14px; color: #333;background: #fff url(../../assets/images/search.svg) no-repeat right 10px center / 25px;}
input.search-filter:hover, input.search-filter:focus{background: #fff url(../../assets/images/search.svg) no-repeat right 10px center / 25px;}
input.date-filter {width: 300px; height: 50px; margin-left: 10px; border: 1px solid #dfdfdf; border-radius: 5px; padding: 0 15px 0 40px; font-weight: 400; font-size: 14px; color: #333;background: #fff url(../../assets/images/date.svg) no-repeat left 10px center / 25px;}
input.date-filter:hover, input.date-filter:focus{background: #fff url(../../assets/images/date.svg) no-repeat left 10px center / 25px;}
.filter-option-checkin select {margin-left: 10px; height: 50px; width: 220px; border: 1px solid #dfdfdf; border-radius: 5px; padding: 0 15px; cursor: pointer; font-size: 14px; font-weight: 400; font-family: "Poppins", sans-serif; -moz-appearance: none; -webkit-appearance: none;background: #fff url(../../assets/images/down-arrow.svg) no-repeat right 10px center / 14px;}
.checkin-report-table table thead tr {background: #f2f3f5; border-bottom: 1px solid #cdcdcd;}
.checkin-report-table table thead tr th {font-weight: 600; font-size: 15px; color: #545555;}
.checkin-report-table table thead tr th:last-child .vs-table-text{justify-content: center !important; }
.checkin-report-table table thead tr th:nth-child(4) .vs-table-text, .checkin-report-table table thead tr th:nth-child(5) .vs-table-text {justify-content: center !important;}
.checkin-report-table table tr.vs-table--tr{border-bottom: 1px solid #cdcdcd;}
.checkin-report-table table tr td:nth-child(4), .checkin-report-table table tr td:nth-child(5){text-align: center;}
.add-user-popup .vs-popup {width: 550px;}
.add-user-hld label{width: 100%; font-size: 14px; color: #000; font-weight: 500; font-family: "Poppins",sans-serif !important;}
.add-user-hld input[type="text"], .add-user-hld input[type="email"]{width: 100%; height: 45px; border: 1px solid #cdcdcd; font-size: 14px; color: #333; font-weight: 400; font-family: "Poppins",sans-serif !important;margin-bottom: 15px;}
.adduser-pop-top h3{font-weight: 500; font-size: 25px; color: #000; font-family: "Poppins", sans-serif !important; margin-bottom: 15px;}
.add-user-btn {display: flex; justify-content: flex-end; align-items: center;}
.add-user-btn button {width: 130px;}
.invite-team-list table tr td:last-child {justify-content: center !important;display: flex;}
.checkin-report-table table tr td:last-child {display: flex; justify-content: center;}
.checkin-type-list table tr td:last-child {display: flex; justify-content: center;}
</style>